'use client';

import { Truck, Clock, MapPin } from '@phosphor-icons/react';

export function DeliveryHero() {
  return (
    <section
      className="relative pt-8 pb-0 sm:pt-10"
      style={{ background: 'linear-gradient(to bottom, var(--bg-secondary, #F5F3FF), var(--bg-primary, #FFFFFF))' }}
    >
      {/* Purple gradient blobs */}
      <div className="blur-blob absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[var(--primary)]/10 blur-[100px]" />
      <div className="blur-blob absolute top-1/2 -left-32 w-[400px] h-[400px] rounded-full bg-[var(--violet-400)]/8 blur-[80px]" />
      <div className="blur-blob absolute bottom-0 right-1/4 w-[300px] h-[300px] rounded-full bg-[var(--primary)]/6 blur-[90px]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left content — CSS-only entrance animations */}
          <div className="space-y-7">
            {/* Badge — SEO-сигнал «доставка роллов и суши» */}
            <div className="animate-fade-up">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--primary-subtle)] text-[var(--primary)] text-sm font-semibold">
                <Truck weight="fill" className="w-4 h-4" />
                Доставка роллов и суши в Ростове-на-Дону
              </span>
            </div>

            {/* Heading — H1 с ключом для поисковиков.
                Размеры: 28px → 36px → 48px → 60px. Без &nbsp;/&lt;br&gt; внутри
                длинных фраз — пусть браузер сам выбирает перенос по ширине экрана. */}
            <h1
              className="text-[28px] sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black leading-[1.1] tracking-tight text-[var(--text-primary)] animate-fade-up break-words"
              style={{ animationDelay: '80ms' }}
            >
              <span className="text-[var(--primary)]">Доставка роллов и суши</span>{' '}
              в Ростове-на-Дону
            </h1>

            {/* Subtitle — уменьшил text-base на mobile, чтобы влазили длинные
                названия районов ("Ворошиловский"). Перечисление районов даём
                в одну строку — браузер перенесёт по словам. */}
            <p
              className="text-base sm:text-lg lg:text-xl text-[var(--text-secondary)] max-w-xl leading-relaxed animate-fade-up"
              style={{ animationDelay: '160ms' }}
            >
              Привозим заказы по большей части города за 60–120 минут.
              Кировский, Ленинский, Ворошиловский, Советский районы и пригороды.
              Проверьте свой адрес и стоимость доставки на карте ниже.
            </p>

            {/* Stats row */}
            <div
              className="flex flex-wrap gap-6 animate-fade-up"
              style={{ animationDelay: '240ms' }}
            >
              {[
                { icon: Clock, label: '60–120 мин', desc: 'Среднее время' },
                { icon: MapPin, label: 'Ростов-на-Дону', desc: 'Зона покрытия' },
                { icon: Truck, label: 'Ежедневно', desc: '11:00 — 22:00' },
              ].map((stat, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-xl bg-[var(--primary-subtle)] flex items-center justify-center shrink-0">
                    <stat.icon weight="fill" className="w-5 h-5 text-[var(--primary)]" />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-[var(--text-primary)]">{stat.label}</p>
                    <p className="text-xs text-[var(--text-tertiary)]">{stat.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — photo, desktop */}
          <div className="relative hidden lg:flex items-center justify-center h-[460px] animate-fade-in" style={{ animationDelay: '200ms' }}>
            <img
              src="https://cdn.aziatochka.ru/aziatochka/delivery.webp"
              alt="Доставка Азиаточка"
              className="w-full h-full object-contain rounded-3xl"
            />
          </div>
        </div>

        {/* Mobile photo — smaller, right under stats */}
        <div
          className="lg:hidden -mt-14 -mb-12 relative z-10 flex justify-end animate-fade-in"
          style={{ animationDelay: '300ms' }}
        >
          <img
            src="https://cdn.aziatochka.ru/aziatochka/delivery.webp"
            alt="Доставка Азиаточка"
            className="w-48 object-contain"
          />
        </div>
      </div>
    </section>
  );
}
